module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1035-f97452508318e7f0a85a5daf41148b77.png";